export const joinBasePath = (basePath: string, path = '') => {
  const normalizedBasePath = basePath.replace(/\/+$/, '')
  const normalizedPath = path.replace(/^\/+/, '')

  if (!normalizedPath) {
    return normalizedBasePath || '/'
  }

  return `${normalizedBasePath}/${normalizedPath}`
}
